import {
  addDays,
  addMonths,
  addYears,
  endOfDay,
  endOfMonth,
  endOfYear,
  format,
  startOfDay,
  startOfMonth,
  startOfYear,
} from "date-fns";
import type { CalendarScale } from "./calendarModel";

export const streamRadius = (scale: CalendarScale) =>
  scale === "year" ? 1 : scale === "day" ? 3 : 2;
export const periodStart = (date: Date, scale: CalendarScale) =>
  scale === "year"
    ? startOfYear(date)
    : scale === "month"
      ? startOfMonth(date)
      : startOfDay(date);
export const periodEnd = (date: Date, scale: CalendarScale) =>
  scale === "year"
    ? endOfYear(date)
    : scale === "month"
      ? endOfMonth(date)
      : endOfDay(date);
export const shiftPeriod = (date: Date, scale: CalendarScale, step: number) =>
  scale === "year"
    ? addYears(date, step)
    : scale === "month"
      ? addMonths(date, step)
      : addDays(date, step);
export const periodKey = (date: Date, scale: CalendarScale) =>
  format(
    date,
    scale === "year" ? "yyyy" : scale === "month" ? "yyyy-MM" : "yyyy-MM-dd",
  );
export function periodWindow(date: Date, scale: CalendarScale) {
  const radius = streamRadius(scale),
    first = periodStart(date, scale);
  return Array.from({ length: radius * 2 + 1 }, (_, index) =>
    shiftPeriod(first, scale, index - radius),
  ).filter((item) => item.getFullYear() >= 1 && item.getFullYear() <= 9999);
}
